<template>
    <app-confirmation :title="myResources.title"
                      :confirm-text="myResources.ctaSave"
                      confirm-icon-class="fas fa-save"
                      @cancel="onCancel"
                      @confirm="onSave">
        <p>{{ myResources.introText }}</p>
    </app-confirmation>
</template>

<script>

import AppConfirmation from '@/components/app-core/app-confirmation'
import ResourcesHelper from '@/components/resources-helper'

export default {
    mixins: [
        ResourcesHelper,
    ],

    computed: {
        /**
         * @returns {AppCoreModalsSaveDialogResources}
         */
        myResources() {
            return this.parseResources('components.appCore.modals.saveDialog')
        },
    },

    data() {
        return {
            saving: false,
        }
    },

    methods: {
        onCancel(ev) {
            this.$eventbus.$emit(this.$appevents.hideModalWithoutActions, ev)
        },

        onSave(ev) {
            this.$eventbus.$emit(this.$appevents.hideModal, ev)
        },
    },

    components: {
        AppConfirmation,
    },
}

</script>
